export default __webpack_public_path__ + "static/media/IndustrialNavMapFinal-01.cb2fab49.png";